import { generatePath, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetHotelPolicyI18nParams = () => {
	const { hotelID, langCode } = useParams<ParamParseKey<typeof PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.I18N>>();
	const activeLangCode = langCode as LangCode;

	if (!hotelID || !activeLangCode) {
		throw new Error("ホテルIDまたは言語コードがありません");
	}

	const navigator = {
		default: generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP, { hotelID }),
		i18n: (langCode: LangCode) => generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.I18N, { hotelID, langCode }),
	};

	return {
		hotelID: hotelID,
		activeLangCode,
		navigator,
	};
};
